import React from 'react';

import * as s from './Labels.css';

/**
 * Лейбл "Лучший совет"
 */
export const BestAdviceLabel = () => <div className={`${s['wrapper']} ${s['best-advice']}`}>Лучший совет</div>;
